<div class="flex flex-row justify-between items-center mb-7">
  <div class="flex flex-row md:gap-3 items-center">
    <div class="flex flex-row flex-nowrap md:gap-3 items-center">
      <h1 class="headeradminui-text md:break-keep">
        Manage Master Data Config
      </h1>
    </div>
  </div>
  <button nz-button nzType="primary" (click)="openDrawer()">
    Add Master Data Config
  </button>
</div>

<ng-template #tableHead>
  <div nz-row nzJustify="space-between">
    <div nz-col>
      <span class="font-bold">Master Data Config</span>
    </div>
  </div>
</ng-template>

<nz-spin
  [nzSpinning]="tableLoading"
  nzTip="Fetching data......"
  class="w-auto h-screen"
>
  <nz-table
    #tableHead
    [nzBordered]="true"
    [nzData]="rows"
    [nzSize]="'middle'"
    [nzShowPagination]="false"
    [nzScroll]="{ y: '500px' }"
  >
    <thead>
      <tr>
        <th nzWidth="25%">Category</th>
        <th nzWidth="25%">Fields</th>
        <th nzWidth="25%">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of rows">
        <td>{{ r.category }}</td>
        <td>
          <div class="flex flex-col gap-1">
            <div *ngFor="let f of r.configFields">
              {{ f.key }}<span *ngIf="f.dataType"> ({{ f.dataType }})</span>
            </div>
          </div>
        </td>
        <td>
          <button nz-button nzSize="small" (click)="editRow(r)">Edit</button>
          <button
            nz-button
            nzType="default"
            nzSize="small"
            class="ml-2"
            (click)="addMasterData(r.category)"
          >
            Manage Master Data
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-spin>

<nz-drawer
  [nzVisible]="isDrawerVisible"
  [nzClosable]="true"
  [nzWidth]="600"
  (nzOnClose)="closeDrawer()"
  nzTitle="Add Master Data Config"
  [nzFooter]="footer"
>
  <ng-template #footer>
    <div class="flex justify-end gap-2 mt-4">
      <button nz-button (click)="closeDrawer()" type="button">Cancel</button>
      <button
        nz-button
        nzType="primary"
        [disabled]="isSubmitting || form.invalid"
        type="button"
        (click)="submit()"
      >
        {{ isSubmitting ? "Saving..." : "Save" }}
      </button>
    </div>
  </ng-template>
  <ng-container *nzDrawerContent>
    <form [formGroup]="form" class="flex flex-col gap-4" (ngSubmit)="submit()">
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzRequired>Category</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-select formControlName="category" nzPlaceHolder="Select category">
            <nz-option
              *ngFor="let c of categories"
              [nzLabel]="c"
              [nzValue]="c"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzSpan]="8" nzRequired>Master Data Type</nz-form-label>
        <nz-form-control [nzSpan]="16">
          <nz-select formControlName="masterDataTypes" nzPlaceHolder="Select master data type">
            <nz-option
              *ngFor="let m of masterDataTypes"
              [nzLabel]="m"
              [nzValue]="m"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <div formArrayName="fields" class="flex flex-col gap-4">
        <div
          *ngFor="let fg of fields.controls; let i = index"
          [formGroupName]="i"
          class="rounded border p-3 flex flex-col gap-2"
        >
          <div class="flex justify-between items-center mb-2">
            <h3 class="text-base font-medium">Field {{ i + 1 }}</h3>
            <div class="flex gap-2">
              <button
                nz-button
                nzSize="small"
                type="button"
                (click)="duplicateField(i)"
              >
                Duplicate
              </button>
              <button
                nz-button
                nzType="default"
                nzDanger
                nzSize="small"
                type="button"
                (click)="removeField(i)"
                [disabled]="fields.length === 1"
              >
                Remove
              </button>
            </div>
          </div>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Key</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <input nz-input formControlName="key" placeholder="Unique key" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8">Data Type</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-select
                formControlName="dataType"
                nzPlaceHolder="Select data type"
              >
                <nz-option
                  *ngFor="let d of dataTypes"
                  [nzLabel]="d"
                  [nzValue]="d"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8">Field Type</nz-form-label>
            <nz-form-control [nzSpan]="16">
              <nz-select
                formControlName="fieldType"
                nzPlaceHolder="Select field type"
              >
                <nz-option
                  *ngFor="let f of allowedFieldTypesByIndex(i)"
                  [nzLabel]="f"
                  [nzValue]="f"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <ng-container
            *ngIf="
              fg.get('dataType')!.value !== 'StringArray' &&
              fg.get('dataType')!.value !== 'boolean'
            "
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="8">Unique</nz-form-label>
              <nz-form-control [nzSpan]="16">
                <nz-switch formControlName="unique"></nz-switch>
              </nz-form-control>
            </nz-form-item>
          </ng-container>
          <ng-container *ngIf="fg.get('dataType')!.value !== 'boolean'">
            <nz-form-item>
              <nz-form-label [nzSpan]="8">Mandatory</nz-form-label>
              <nz-form-control [nzSpan]="16">
                <nz-switch formControlName="mandatory"></nz-switch>
              </nz-form-control>
            </nz-form-item>
          </ng-container>
          <!-- <ng-container *ngIf="(fg.get('dataType')!.value === 'StringArray' || fg.get('dataType')!.value === 'string') && fg.get('fieldType')!.value === 'dropdown'">
              <nz-form-item>
                <nz-form-label [nzSpan]="8" nzRequired>Dropdown Options</nz-form-label>
                <nz-form-control [nzSpan]="16">
                  <nz-select formControlName="dropdownOptions" nzPlaceHolder="Select dropdown options">
                    <nz-option *ngFor="let o of dropdownOptions" [nzLabel]="o" [nzValue]="o"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </ng-container> -->

          <ng-container
            *ngIf="
              (fg.get('dataType')!.value === MasterDataDataType.StringArray ||
                fg.get('dataType')!.value === MasterDataDataType.String) &&
              fg.get('fieldType')!.value === MasterDataFieldType.Dropdown
            "
          >
            <nz-form-item>
              <nz-form-label [nzSpan]="8" nzRequired
                >Dropdown Options</nz-form-label
              >
              <nz-form-control [nzSpan]="16">
                <nz-select
                  formControlName="dropdownOptions"
                  nzPlaceHolder="Select dropdown options"
                >
                  <nz-option
                    *ngFor="let o of getDropdownOptions()"
                    [nzLabel]="o"
                    [nzValue]="o"
                  ></nz-option>
                </nz-select>
                <!-- Only show when 'OTHERS' is selected -->
                <ng-container *ngIf="fg.get('customDropdownOptions')">
                  <nz-form-item class="mt-3">
                    <nz-form-label [nzSpan]="8">Custom Options</nz-form-label>
                    <nz-form-control [nzSpan]="16">
                      <div class="flex gap-2 flex-wrap">
                        <input
                          class="mr-2"
                          nz-input
                          placeholder="Add custom option"
                          #customInput
                        />
                        <button
                          nz-button
                          nzType="default"
                          type="button"
                          (click)="
                            addCustomOption(i, customInput.value);
                            customInput.value = ''
                          "
                        >
                          Add
                        </button>
                      </div>
                      <div class="flex gap-2 flex-wrap mt-2">
                        <span
                          *ngFor="
                            let opt of customDropdownOptionsControl(i).controls;
                            let j = index
                          "
                          class="px-2 py-1 bg-gray-200 rounded flex items-center gap-1"
                        >
                          {{ opt.value }}
                          <button
                            type="button"
                            class="text-red-500"
                            (click)="removeCustomOption(i, j)"
                          >
                            x
                          </button>
                        </span>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </ng-container>
              </nz-form-control>
            </nz-form-item>
          </ng-container>
        </div>

        <div class="flex">
          <button nz-button type="button" (click)="addField()">
            Add another field
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</nz-drawer>

<!-- <nz-table
#basicTable
  [nzData]="rows"
  [nzLoading]="tableLoading"
  [nzBordered]="true"
  [nzSize]="'middle'"
  class="mt-4 w-full"
  nzTableLayout="fixed"
  nzShowPagination="false"
  [nzShowPagination]="false"
  [nzScroll]="{ x: '100%' }"
>
  <thead>
    <tr>
      <th nzWidth="25%">Category</th>
      <th nzWidth="25%">Fields</th>
      <th nzWidth="25%">Action</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let r of rows">
      <td>{{ r.category }}</td>
      <td>
        <div class="flex flex-col gap-1">
          <div *ngFor="let f of r.configFields">{{ f.key }}<span *ngIf="f.dataType"> ({{ f.dataType }})</span></div>
        </div>
      </td>
      <td>
        <button nz-button nzSize="small" (click)="editRow(r)">Edit</button>
        <button nz-button nzType="default" nzSize="small" class="ml-2" (click)="addMasterData()">Add Master Data</button>
      </td>
    </tr>
  </tbody>
</nz-table> -->
